<template>
  <div>
    <b-modal
      no-fade
      size="xl2"
      id="modal-project"
      no-close-on-esc
      no-close-on-backdrop
      title="Projeto"
    >
      <!-- <template v-slot:modal-title="{}">
        <div class="project-modal-title">
            <img :src="project.logo" alt="data" />
            <h5>Projeto</h5>
        </div>
      </template>-->
      <div>
        <b-tabs
          content-class="v-tab-content"
          v-model="tabIndex"
          active-nav-item-class="v-tab-active"
          small
        >
          <b-tab title="Projeto">
            <b-form-row>
              <b-col lg="2">
                <b-form-group label="ID" label-size="sm" label-for="projeto_id">
                  <b-form-input
                    size="sm"
                    id="projeto_id"
                    v-model="project.projeto_id"
                    disabled
                    trim
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="4">
                <b-form-group
                  label="Nº Contrato"
                  label-size="sm"
                  label-for="nr_contrato"
                >
                  <b-form-input
                    size="sm"
                    id="nr_contrato"
                    maxlength="50"
                    v-model="project.nr_contrato"
                    :disabled="action === 'view'"
                    trim
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="2">
                <b-form-group
                  label="Data de Início"
                  label-size="sm"
                  label-for="dt_inicio"
                >
                  <date-picker
                    input-class="form-control form-control-sm"
                    :disabled="action === 'view'"
                    :clearable="false"
                    maxlength="10"
                    format="DD/MM/YYYY"
                    value-type="YYYY-MM-DD"
                    v-model="project.dt_inicio"
                  ></date-picker>
                </b-form-group>
              </b-col>
              <b-col lg="4">
                <b-form-group
                  label="Projeto"
                  label-size="sm"
                  label-for="empresa"
                >
                  <b-form-input
                    size="sm"
                    id="empresa"
                    maxlength="100"
                    v-model="project.empresa"
                    :disabled="action === 'view'"
                    trim
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col lg="12">
                <b-form-group label-size="sm" label="Objeto" label-for="titulo">
                  <b-form-textarea
                    id="titulo"
                    :disabled="action === 'view'"
                    v-model="project.titulo"
                    rows="3"
                    maxlength="10000"
                    no-resize
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col lg="6">
                <b-form-group label-size="sm" label="UO" label-for="uo_id">
                  <v-select
                    id="uo_id"
                    :disabled="action === 'view'"
                    :options="combos.uo"
                    label="descricao"
                    :reduce="(uo) => uo.uo_id"
                    :clearable="false"
                    v-model="project.uo_id"
                  >
                    <template v-slot:option="option">{{
                      `${option.uo_id} - ${option.descricao}`
                    }}</template>
                    <template v-slot:selected-option="option">{{
                      `${option.uo_id} - ${option.descricao}`
                    }}</template>
                    <template #no-options="{}"
                      >Sem dados a serem exibidos</template
                    >
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group
                  label-size="sm"
                  label="Unidade de Negócio"
                  label-for="unidade_id"
                >
                  <v-select
                    id="unidade_id"
                    :disabled="action === 'view'"
                    :options="combos.bu"
                    label="unidade_id"
                    :reduce="(bu) => bu.unidade_id"
                    :clearable="false"
                    v-model="project.unidade_id"
                  >
                    <template v-slot:option="option">{{
                      `${option.unidade_id} - ${option.descricao}`
                    }}</template>
                    <template v-slot:selected-option="option">{{
                      `${option.unidade_id} - ${option.descricao}`
                    }}</template>
                    <template #no-options="{}"
                      >Sem dados a serem exibidos</template
                    >
                  </v-select>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col lg="12">
                <b-form-group
                  label-size="sm"
                  label="Cliente"
                  label-for="cliente_id"
                >
                  <v-select
                    id="cliente_id"
                    :disabled="action === 'view'"
                    :options="combos.customers"
                    label="cliente_id"
                    :reduce="(customer) => customer.cliente_id"
                    :clearable="false"
                    v-model="project.cliente_id"
                  >
                    <template v-slot:option="option">{{
                      `${option.cliente_id} - ${option.razao_social}`
                    }}</template>
                    <template v-slot:selected-option="option">{{
                      `${option.cliente_id} - ${option.razao_social}`
                    }}</template>
                    <template #no-options="{}"
                      >Sem dados a serem exibidos</template
                    >
                  </v-select>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col lg="6">
                <b-form-group
                  label-size="sm"
                  label="Gestor"
                  label-for="gestor_id"
                >
                  <v-select
                    id="gestor_id"
                    :disabled="action === 'view'"
                    :options="combos.users"
                    label="name"
                    :reduce="(user) => user.email"
                    :clearable="false"
                    v-model="project.gestor_id"
                  >
                    <template #no-options="{}"
                      >Sem dados a serem exibidos</template
                    >
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group
                  label-size="sm"
                  label="Tipo de Projeto"
                  label-for="tipo_id"
                >
                  <v-select
                    id="tipo_id"
                    :disabled="action === 'view'"
                    :options="combos.types"
                    label="descricao"
                    :reduce="(type) => type.tipo_id"
                    :clearable="false"
                    v-model="project.tipo_id"
                  >
                    <template #no-options="{}"
                      >Sem dados a serem exibidos</template
                    >
                  </v-select>
                </b-form-group>
              </b-col>
            </b-form-row>
          </b-tab>
          <b-tab title="Observações">
            <b-form-row>
              <b-col lg="12">
                <b-form-textarea
                  :disabled="action === 'view'"
                  id="textarea"
                  v-model="project.observacoes"
                  placeholder
                  rows="8"
                  no-resize
                ></b-form-textarea>
              </b-col>
            </b-form-row>
          </b-tab>
          <b-tab active :disabled="action == 'new'" title="Anexos">
            <FileManager :projectID="project.projeto_id" :action="action" />
          </b-tab>
          <b-tab :disabled="action == 'new'" title="Comentários">
            <b-form-row>
              <b-col lg="12">
                <b-form-group
                  label-size="sm"
                  label="Enviar Mensagem"
                  label-for="mensagem"
                >
                  <b-input-group class="mt-1 mb-2">
                    <b-form-textarea
                      id="mensagem"
                      v-model="message"
                      maxlength="500"
                      rows="2"
                      no-resize
                    ></b-form-textarea>
                    <b-input-group-append>
                      <b-button @click="sendMessage()" variant="info">
                        <i class="fas fa-paper-plane"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col lg="12">
                <div style="width:100%; max-height:300px; overflow-y: auto">
                  <TimeLine
                    dateLocale="pt-BR"
                    :uniqueTimeline="true"
                    :uniqueYear="true"
                    :timeline-items="timelineItems"
                    :message-when-no-items="'Sem Mensagens'"
                  />
                </div>
              </b-col>
            </b-form-row>
          </b-tab>
          <b-tab :disabled="action == 'new'" title="Participantes">
            <b-form-row>
              <b-col lg="12">
                <b-table
                  small
                  show-empty
                  bordered
                  responsive
                  hover
                  selectable
                  select-mode="single"
                  selected-variant="primary"
                  head-variant="dark"
                  :items="participTable.data"
                  :fields="participTable.fields"
                  :busy="participTable.busy"
                  empty-text="Sem dados para exibir"
                >
                  <template v-slot:table-busy>
                    <div class="text-center">
                      <b-spinner class="align-middle mr-1"></b-spinner>
                      <strong>Carregando...</strong>
                    </div>
                  </template>
                  <template v-slot:cell(actions)="data">
                    <b-button
                      v-if="permitParticipants"
                      size="sm"
                      variant="danger"
                      @click="deleteParticipant(data.item)"
                    >
                      <i class="fas fa-trash"></i>
                    </b-button>
                  </template>
                </b-table>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col lg="12">
                <b-button
                  v-if="permitParticipants"
                  @click="showAddParticipants"
                  variant="primary"
                  size="sm"
                  >Convidar</b-button
                >
              </b-col>
            </b-form-row>
          </b-tab>
        </b-tabs>
      </div>
      <template v-slot:modal-footer>
        <b-button
          v-if="action !== 'view'"
          v-show="tabIndex === 0"
          size="sm"
          @click="saveRecord()"
          variant="primary"
        >
          <i class="fas fa-check"></i> Gravar
        </b-button>
        <b-button size="sm" @click="() => $bvModal.hide('modal-project')"
          >Cancelar</b-button
        >
      </template>
    </b-modal>
    <AddParticipants @select="onSelectParticipants" />
  </div>
</template>

<script>
import { baseApiUrl, showError, validateDate } from "@/global";
import AddParticipants from "./AddParticipants";
import FileManager from "@/components/projects/FileManager";
import TimeLine from "@/components/timeLine/TimeLine";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import axios from "axios";

export default {
  name: "ModalProject",
  components: { AddParticipants, TimeLine, FileManager, DatePicker },
  computed: {
    permitEdit: function() {
      let _perfilid = this.$store.state.user.user.perfil_id;

      if (_perfilid >= 2 && _perfilid !== 4 && _perfilid !== 5) return false;

      return true;
    },
    permitParticipants: function() {
      return this.$store.state.user.user.perfil_id < 5;
    },
  },
  props: {
    project: { type: Object, required: true },
    action: { type: String, required: true, default: "view" },
  },
  data: function() {
    return {
      tabIndex: 0,
      timelineItems: [],
      message: "",
      participTable: {
        busy: false,
        data: [],
        fields: [
          { key: "usuario.name", label: "Nome" },
          { key: "usuario.email", label: "E-mail" },
          { key: "actions", label: "Ações" },
        ],
      },
      combos: {
        uo: [],
        bu: [],
        customers: [],
        users: [],
      },
    };
  },
  methods: {
    onSelectParticipants(event) {
      let _users = [];
      for (const iterator of event) {
        _users.push({ usuario_id: iterator.email });
      }
      axios
        .post(
          `${baseApiUrl}/projetos/${this.project.projeto_id}/participantes`,
          _users
        )
        .then(() => this.loadParticipants())
        .catch((ex) => {
          showError(ex);
        });
    },
    validateRecord() {
      let _msg = "";
      console.log(this.project.dt_inicio);

      if ((this.project.titulo || "") === "") _msg = "Informe o Título";

      if (!validateDate(this.project.dt_inicio, "YYYY-MM-DD"))
        _msg += (_msg !== "" ? "<br/>" : "") + "Data de Início Inválida!";

      if ((this.project.uo_id || "") === "")
        _msg += (_msg !== "" ? "<br/>" : "") + "Selecione a UO!";

      if ((this.project.unidade_id || "") === "")
        _msg +=
          (_msg !== "" ? "<br/>" : "") + "Selecione a Unidade de Negócio!";

      if ((this.project.cliente_id || "") === "")
        _msg += (_msg !== "" ? "<br/>" : "") + "Selecione o Cliente!";

      if ((this.project.gestor_id || "") === "")
        _msg += (_msg !== "" ? "<br/>" : "") + "Selecione o Gestor!";

      if ((this.project.tipo_id || 0) === 0)
        _msg += (_msg !== "" ? "<br/>" : "") + "Selecione o Tipo do Projeto!";

      if ((this.project.empresa || "") === "")
        _msg += (_msg !== "" ? "<br/>" : "") + "Digite o Projeto!";

      if (_msg !== "") {
        this.$toasted.info(_msg, {
          duration: 4000,
          keepOnHover: true,
          className: "v-toasted-warning",
        });
        return false;
      }
      return true;
    },
    saveRecord() {
      let _saveObj = { ...this.project };

      if (!this.validateRecord()) return;

      // _saveObj.dt_inicio = formatDate(
      //   _saveObj.dt_inicio,
      //   "DD/MM/YYYY",
      //   "YYYY-MM-DD"
      // );

      if (this.action === "new") {
        axios
          .post(`${baseApiUrl}/projetos`, _saveObj)
          .then((resp) => {
            this.$emit("inserted", resp.data);
          })
          .catch((err) => {
            showError(err);
          });
      } else {
        axios
          .put(`${baseApiUrl}/projetos/${this.project.projeto_id}`, _saveObj)
          .then(() => {
            this.$bvModal.hide("modal-project");
            this.$emit("updated");
          })
          .catch((err) => {
            showError(err);
          });
      }
    },
    sendMessage() {
      if (this.message == "") return;
      if (!this.project.projeto_id) return;
      axios
        .post(`${baseApiUrl}/projetos/${this.project.projeto_id}/mensagens`, {
          mensagem: this.message,
          usuario_id: this.$store.state.user.user.email,
        })
        .then(() => {
          this.message = "";
          this.loadMessages();
        })
        .catch(showError);
    },
    showAddParticipants() {
      this.$bvModal.show("modal-add-participant");
    },
    loadCombos() {
      // uo
      axios
        .get(`${baseApiUrl}/uo`)
        .then((resp) => {
          this.combos.uo = resp.data;
        })
        .catch(showError);

      // unidades de negocio
      axios
        .get(`${baseApiUrl}/unidadesnegocio`)
        .then((resp) => {
          this.combos.bu = resp.data;
        })
        .catch(showError);

      // clientes
      axios
        .get(`${baseApiUrl}/clientes`)
        .then((resp) => {
          this.combos.customers = resp.data;
        })
        .catch(showError);

      // usuarios
      axios
        .get(`${baseApiUrl}/usuarios`)
        .then((resp) => {
          this.combos.users = resp.data;
        })
        .catch(showError);

      // tipos
      axios
        .get(`${baseApiUrl}/tiposprojeto`)
        .then((resp) => {
          this.combos.types = resp.data;
        })
        .catch(showError);
    },
    deleteParticipant(item) {
      this.$bvModal
        .msgBoxConfirm(`Excluir o Participante ${item.name}?`, { noFade: true })
        .then((yesno) => {
          if (yesno) {
            axios
              .delete(
                `${baseApiUrl}/projetos/${this.project.projeto_id}/participantes`,
                { data: { usuario_id: item.usuario.email } }
              )
              .then(() => this.loadParticipants())
              .catch((err) => showError(err));
          }
        })
        .catch((err) => showError(err));
    },
    loadMessages() {
      this.timelineItems = [];
      if (this.action == "new") return;

      if (!this.project.projeto_id) return;

      axios
        .get(`${baseApiUrl}/projetos/${this.project.projeto_id}/mensagens`)
        .then((resp) => {
          for (const iterator of resp.data) {
            this.timelineItems.push({
              from: iterator.dt_envio,
              description: iterator.mensagem,
              title: iterator.usuario_id,
              showDayAndMonth: true,
            });
          }
        });
    },
    loadParticipants() {
      this.participTable.data = [];
      if (this.action === "new") return;

      if (!this.project.projeto_id) return;

      this.participTable.busy = true;

      axios
        .get(`${baseApiUrl}/projetos/${this.project.projeto_id}/participantes`)
        .then((resp) => {
          this.participTable.busy = false;
          this.participTable.data = resp.data;
        })
        .catch((ex) => {
          this.participTable.busy = false;
          showError(ex);
        });
    },
  },
  watch: {
    // eslint-disable-next-line
    project: function(valNew, valOld) {
      this.loadParticipants();
      this.loadMessages();
    },
  },
  mounted() {
    this.loadCombos();
  },
};
</script>

<style>
.v-tab-active {
  background-color: #007bff !important;
  color: white !important;
}

.nav-tabs .nav-link {
  border-color: #ddd !important;
}

.v-tab-content {
  border: 1px solid #ddd;
  padding: 10px;
  box-shadow: 1px 1px 5px 0 #ccc;
}

.nav-tabs .nav-link:hover {
  background-color: #ddd !important;
  color: #333 !important;
}
</style>
